/*
 * Dolgum — round 2 of conversion-rate boosters.
 * 1) Sticky "Add to cart" bar on mobile (delegates to the real button — works
 *    correctly whether the Bundle & Save selector or the plain variant picker
 *    is active, since it just clicks whatever the real primary button is).
 * 2) Honest "high demand" badge near the price. NOTE: this store's inventory
 *    is not tracked (dropshipping, unlimited-from-supplier), so there is no
 *    real per-size stock count to show. Rather than fabricate a fake
 *    "only 3 left" number, this shows a generic, truthful demand cue instead.
 * 3) One-sided "refer a friend" share widget: the referred friend gets an
 *    instant 15% code (FRIEND15) via a shareable link. There's no backend
 *    here to track who referred whom, so this does not promise the referrer
 *    an automatic reward — it only shares what can honestly be delivered.
 *
 * Additive/non-destructive: only ever appends new elements, never edits
 * existing theme markup or scripts.
 */
(function () {
  var ACCENT = 'rgb(var(--color-button))';
  var ACCENT_TEXT = 'rgb(var(--color-button-text))';
  var isProductPage = /\/products\//.test(window.location.pathname);
  var isCheckoutish = /\/(cart|checkout|account)\b/.test(window.location.pathname);

  function injectStyle(css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  injectStyle(
    '.eai2-pop{font-family:var(--font-body-family);}' +
    '.eai2-sticky-bar{position:fixed;left:0;right:0;bottom:0;z-index:9997;background:#fff;' +
    'box-shadow:0 -4px 18px rgba(0,0,0,.12);padding:.7rem 1rem;display:flex;align-items:center;' +
    'gap:.75rem;transform:translateY(110%);transition:transform .3s ease;}' +
    '.eai2-sticky-bar.eai2-show{transform:translateY(0);}' +
    '.eai2-sticky-bar img{width:42px;height:42px;border-radius:8px;object-fit:cover;flex-shrink:0;}' +
    '.eai2-sticky-bar__info{flex:1;min-width:0;}' +
    '.eai2-sticky-bar__title{font-size:1.05rem;font-weight:600;color:#1f2937;white-space:nowrap;' +
    'overflow:hidden;text-overflow:ellipsis;}' +
    '.eai2-sticky-bar__price{font-size:1.1rem;font-weight:700;color:' + ACCENT + ';}' +
    '.eai2-sticky-bar__btn{background:' + ACCENT + ';color:' + ACCENT_TEXT + ';border:none;' +
    'border-radius:8px;padding:.8rem 1.3rem;font-size:1.1rem;font-weight:700;cursor:pointer;' +
    'white-space:nowrap;flex-shrink:0;}' +
    '@media screen and (min-width:750px){.eai2-sticky-bar{display:none;}}' +
    '.eai2-demand-badge{display:inline-flex;align-items:center;gap:.4rem;font-size:1.1rem;' +
    'font-weight:600;color:#b45309;background:#fef3c7;border-radius:8px;padding:.4rem .8rem;' +
    'margin:.5rem 0;width:fit-content;}' +
    '.eai2-refer{background:linear-gradient(135deg,rgba(215,174,168,.15),rgba(215,174,168,.05));' +
    'border:1.5px dashed rgba(215,174,168,.6);border-radius:12px;padding:1rem 1.1rem;margin-top:1rem;' +
    'font-family:var(--font-body-family);}' +
    '.eai2-refer__title{font-weight:700;font-size:1.15rem;color:#1f2937;margin:0 0 .3rem;}' +
    '.eai2-refer__sub{font-size:.98rem;color:#6b7280;margin:0 0 .7rem;}' +
    '.eai2-refer__row{display:flex;gap:.5rem;flex-wrap:wrap;}' +
    '.eai2-refer__link{flex:1;min-width:140px;padding:.6rem .8rem;border:1px solid #d1d5db;' +
    'border-radius:8px;font-size:.92rem;color:#374151;background:#fff;overflow:hidden;' +
    'text-overflow:ellipsis;white-space:nowrap;}' +
    '.eai2-refer__copy{background:' + ACCENT + ';color:' + ACCENT_TEXT + ';border:none;' +
    'border-radius:8px;padding:.6rem 1rem;font-size:.95rem;font-weight:700;cursor:pointer;' +
    'white-space:nowrap;}' +
    '.eai2-refer__copy.eai2-copied{background:#16a34a;}'
  );

  /* ---------- 1) Sticky mobile add-to-cart bar ---------- */
  function initStickyBar() {
    if (!isProductPage) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;

    function render() {
      if (document.querySelector('.eai2-sticky-bar')) return;
      var mainBtn = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!mainBtn) return;

      var titleEl = document.querySelector('.product__title h1, h1.product__title, h1');
      var priceEl = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item')
        || document.querySelector('[id^="price-"]');
      var imgEl = document.querySelector('.product__media img, media-gallery img');

      var bar = document.createElement('div');
      bar.className = 'eai2-sticky-bar eai2-pop';
      bar.innerHTML =
        (imgEl ? '<img src="' + imgEl.src + '" alt="">' : '') +
        '<div class="eai2-sticky-bar__info">' +
          '<div class="eai2-sticky-bar__title">' + (titleEl ? titleEl.textContent.trim() : 'Product') + '</div>' +
          '<div class="eai2-sticky-bar__price">' + (priceEl ? priceEl.textContent.trim() : '') + '</div>' +
        '</div>' +
        '<button type="button" class="eai2-sticky-bar__btn">Add to Cart</button>';
      document.body.appendChild(bar);

      bar.querySelector('.eai2-sticky-bar__btn').addEventListener('click', function () {
        var liveBtn = document.querySelector('[id^="ProductSubmitButton-"]');
        if (liveBtn) liveBtn.click();
      });

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('eai2-show');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('eai2-show');
          } else {
            bar.classList.remove('eai2-show');
          }
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    render();
    var mo = new MutationObserver(render);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 2) Honest demand badge (no fabricated stock counts) ---------- */
  function initDemandBadge() {
    if (!isProductPage) return;

    var messages = [
      '🔥 Trending today',
      '⚡ High demand right now',
      '🐾 A cat-parent favorite this week'
    ];

    function render() {
      var priceEl = document.querySelector('[id^="price-"]');
      if (!priceEl || priceEl.dataset.eaiDemandDone === '1') return;
      priceEl.dataset.eaiDemandDone = '1';

      var badge = document.createElement('div');
      badge.className = 'eai2-demand-badge eai2-pop';
      badge.textContent = messages[Math.floor(Math.random() * messages.length)];

      var countdown = document.querySelector('.eai-countdown');
      if (countdown) {
        countdown.insertAdjacentElement('afterend', badge);
      } else {
        priceEl.insertAdjacentElement('afterend', badge);
      }
    }

    render();
    var mo = new MutationObserver(render);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 3) Refer-a-friend share widget (one-sided, honest) ---------- */
  function initReferral() {
    if (!isProductPage || isCheckoutish) return;

    function render() {
      var trustRow = document.querySelector('.eai-trust-row');
      if (!trustRow || document.querySelector('.eai2-refer')) return;

      var shareUrl = window.location.origin + '/discount/FRIEND15?redirect=' + encodeURIComponent(window.location.pathname);

      var box = document.createElement('div');
      box.className = 'eai2-refer eai2-pop';
      box.innerHTML =
        '<p class="eai2-refer__title">🎁 Refer a Friend</p>' +
        '<p class="eai2-refer__sub">Share this link — your friend gets 15% off their first order, automatically.</p>' +
        '<div class="eai2-refer__row">' +
          '<input class="eai2-refer__link" type="text" readonly value="' + shareUrl + '">' +
          '<button type="button" class="eai2-refer__copy">Copy Link</button>' +
        '</div>';
      trustRow.insertAdjacentElement('afterend', box);

      var copyBtn = box.querySelector('.eai2-refer__copy');
      var linkInput = box.querySelector('.eai2-refer__link');
      copyBtn.addEventListener('click', function () {
        linkInput.select();
        var done = function () {
          copyBtn.textContent = 'Copied!';
          copyBtn.classList.add('eai2-copied');
          setTimeout(function () {
            copyBtn.textContent = 'Copy Link';
            copyBtn.classList.remove('eai2-copied');
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(shareUrl).then(done).catch(function () {
            document.execCommand('copy');
            done();
          });
        } else {
          document.execCommand('copy');
          done();
        }
      });
    }

    render();
    var mo = new MutationObserver(render);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  initStickyBar();
  initDemandBadge();
  initReferral();
})();
